import { useEffect, useMemo } from 'react';
import { parsePostContext } from './api/client';
import { CommentsPage } from './pages/CommentsPage';
import { ru } from './i18n/ru';

function resolveStartParam(): string | undefined {
  // MAX SDK кладёт start_param в initDataUnsafe (основной способ)
  const fromSdk = window.WebApp?.initDataUnsafe?.start_param;
  if (fromSdk) return fromSdk;
  // Fallback: MAX может передать startapp прямо в URL query (?startapp=c_...)
  return new URLSearchParams(window.location.search).get('startapp') ?? undefined;
}

export default function App() {
  const context = useMemo(() => {
    return parsePostContext(resolveStartParam());
  }, []);

  // Сообщаем клиенту MAX, что мини-апп загружен и готов к показу.
  // Без ready()/show() клиент может дольше держать WebView в загрузке.
  useEffect(() => {
    try {
      window.WebApp?.ready?.();
      window.WebApp?.show?.();
    } catch {
      /* SDK может отсутствовать вне MAX (dev/браузер) — игнорируем */
    }
  }, []);

  if (!context) {
    return <div className="error">{ru.errorInit}</div>;
  }

  return <CommentsPage context={context} />;
}
